import Navbar from './components/Navbar.tsx'
import React from 'react'
import Hero from './components/Hero.tsx'
import Features from './components/Features.tsx'
import Services from './components/Services.tsx'
import Work from './components/Work.tsx'
import Process from './components/Process.tsx'
import Testimonials from './components/Testimonials.tsx'
import Footer from './components/Footer.tsx'
import Contact from './components/Contact.tsx'

export default function App() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-ink-950">
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Services />
        <Work />
        <Process />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
